import React from 'react';

import MojitoApplications from 'mojito/applications';

import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';
import {isMobile} from '#core/utils/context-utils.js';
import {ensureHierarchy} from '#core/utils/config-utils.js';
import {removeStartingSlash} from '#core/utils/url-utils.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';
import {generateSearchInput} from '#core/application/modules/tiles/search/search-input.js';
import {
    generateRecentSearch,
    generateSearchResultGroup,
    generateSearchResultItem,
} from '#core/application/modules/tiles/search/search-result.js';
import {generateToggleButtonRow} from '#core/application/modules/tiles/button/toggle-button/index.js';

import {SearchPage} from './search-page.jsx';

import SCHEMA from './search.schema.yaml';
import PALETTE_SCHEMA from './search.palette-schema.yaml';

const {RouterStore} = MojitoApplications.Common;

// NOTE: We will move this feature to tile when Mojito allow us to configure all children components inside SearchView
class SearchFeature extends AbstractVisualFeature {
    get name() {
        return 'Search';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    get configSchema() {
        return SCHEMA;
    }

    get searchOptions() {
        return this.config.searchOptions;
    }

    updateViewsConfig(viewsConfig) {
        const RoutingView = ensureHierarchy(viewsConfig, 'RoutingView');
        const routeResolver = RouterStore.routeResolverFactory.getRouteResolver();

        RoutingView.customRoutes = RoutingView.customRoutes || [];
        RoutingView.customRoutes.push({
            path: routeResolver.enrichWithRoot(removeStartingSlash(this.config.searchPagePath)),
            component: () => <SearchPage />,
        });

        super.updateViewsConfig(viewsConfig);
    }

    getSerializableVisualConfig(PALETTE) {
        if (!isMobile()) return; // For the desktop you can find styles in application header

        return {
            SearchView: {
                style: {
                    searchBox: {
                        zIndex: 2,
                        _mobile_flexBasis: '100%', // fix search overlay layout
                    },
                    container: {
                        margin: '0 0 10px 0',
                    },
                    resultsContainer: {
                        _mobile_maxHeight: '80vh',
                        padding: '8px 0',
                    },
                },
                searchInput: generateSearchInput(PALETTE.SEARCH_INPUT),
                messageText: {
                    style: {
                        wordBreak: 'break-word',
                        ...PALETTE.SEARCH_RESULT.SEARCH_RECENT_ITEM_TEXT,
                    },
                },
                messageContainer: {
                    style: {
                        padding: '8px',
                    },
                },
                sportMenu: generateToggleButtonRow(PALETTE.SEARCH_SPORT_MENU_SWITCHER, true),
            },
            RecentSearch: generateRecentSearch(PALETTE.SEARCH_RESULT),
            SearchResultGroup: generateSearchResultGroup(PALETTE.SEARCH_RESULT),
            SearchResultItem: generateSearchResultItem(PALETTE.SEARCH_RESULT),
            SearchOverlay: {
                overlay: {
                    style: {
                        overlay: {
                            ...resolveBackground(PALETTE.SEARCH_OVERLAY_BG),
                        },
                    },
                },
                searchBackButtonIcon: icon(PALETTE.SEARCH_OVERLAY_BACK_BUTTON_ICON_COLOR),
            },
        };
    }
}

export const Search = new SearchFeature(allVisuals);
